import { defineStore } from 'pinia';
import api from '@/api/api';
import type {IBlogPost} from "@typesDef/blog.types";

export const useDashboardStore = defineStore('dashboard', {
    state: () => ({
        latestData: undefined as Record<string, any> | undefined,
        blogData: undefined as Array<IBlogPost> | undefined,
    }),
    getters: {

    },
    actions: {
        clearMyData(): void {
            this.latestData = undefined;
        },
        async fetchDashboardData(enforceFetch: boolean=false): Promise<object | undefined> {
            if (enforceFetch || this.latestData === undefined) {
                this.latestData = await api.getDocument<any>('dashboard', '', {
                    enforce: enforceFetch
                });
            }
            return this.latestData;
        },
        async fetchDashboardBlogData(): Promise<Array<IBlogPost> | undefined> {
            if (this.blogData === undefined) {
                this.blogData = await api.getDocuments<any>('dashboard/news', {} );
            }
            return this.blogData;
        },
        /*
        async fetchUpdatesApplications(): Promise<IApplication[]> {
            this.updatesApplications = await api.getDocuments<IApplication>('applications',  {
                l: LIMIT,
                sk: 0,
                q: JSON.stringify({ status: { $ne: 'pending' }}),
                s: JSON.stringify({updatedAt: -1})
            });
            return this.updatesApplications;
        },
        async fetchNewestEvents(): Promise<IEvent[]> {
            this.newestEvents = await api.getDocuments<IEvent>('events', {
                l: LIMIT,
                sk: 0,
                // TODO add type query based on your profile
                s: JSON.stringify({createdAt: -1})
            });
            return this.newestEvents;
        },
        async fetchUpdatesMyEvents(): Promise<IEvent[]> {
            this.updatesMyEvents = await api.getDocuments<IEvent>('events/my', {
                l: LIMIT,
                sk: 0,
                s: JSON.stringify({updatedAt: -1})
            });
            return this.updatesMyEvents;
        },

         */

    }
});
